<template>
  <v-container grid-list-xl class="pa-0">
    <v-row wrap>
      <!-- <v-col cols="12">
        <m-alert
          show
          :title="alert.pengguna.list.judul"
          :info="alert.pengguna.list.deskripsi"
          closable
        ></m-alert>
      </v-col>-->
      <v-col cols="12">
        <m-card-list
          title="Daftar Admin LMS"
          search
          id-key
          filter
          @refresh="load"
          :items="items"
          footerLabel="Admin LMS"
          @search="(search)=>{textSearch=search;load()}"
          :page="page"
          @change:page="(pg)=>{cp=pg;load()}"
          @add="add"
          footer
        >
          <template v-slot:items="{props,item}">
            <tr>
              <td>
                <v-row wrap>
                  <v-col cols="2" align="center" justify="center">
                    <v-avatar :size="45" color="grey lighten-4">
                      <v-img
                        :src="item.foto?item.foto.url.thumbnail:'https://cdn.siap.id/s3/asset illustrasi/Illustrasi/bg-default.png'"
                        alt="avatar"
                      />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10" class="my-1 py-0">
                    <span>Nama</span>
                    <p class="title my-0 py-0 red--text">{{pVal(item,'name')}}</p>
                  </v-col>
                </v-row>
              </td>
              <td>
                <p class="my-0 py-0">Surel</p>
                <p class="title my-0 py-0">{{pVal(item,'email')}}</p>
              </td>
              <td>
                <p class="my-0 py-0 font-weight-bold">Kelas</p>
                <v-chip
                  v-for="item in item.kelas"
                  :key="item.index"
                  outlined
                  class="primary mx-1 primary--text justify-center"
                >{{item.nama}}</v-chip>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../user/components/Form.vue";

export default {
  components: {
    ChangeDlg
    // DetailDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o)
        }
        // {
        //   title: "Ubah Peran",
        //   click: (i, o) => this.setRole(o)
        // }
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("user/get", {
          instansi_id: this.instansi_id,
          params: {
            grup_id: 2,
            page: this.cp,
            s: this.textSearch,
            peran: this.peran
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    ajukan(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasikan Anggota ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.judul} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("user/ajukan", { obj: item })
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    setRole(item) {
      this.$confirm(
        `Apakah anda yakin akan mengubah peran pengguna sesuai data yang Anda pilih?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${item.name}
        </div>
        `,
        {
          role: [
            { id: 2, name: "Kontributor" },
            { id: 3, name: "Kurator" }
          ],
          mapel: this.itemMapels
        },
        "Ubah Peran",
        item
      )
        .then(res => {
          var obj = {
            user_id: item.id,
            role_id: typeof res.role == "object" ? res.role.id : res.role,
            mapel: res.mapel
            // is_simpatika:
            //   typeof res.tenant === "object" ? res.tenant.id : res.tenant
          };
          this.$store
            .dispatch("user/setRole", obj)
            .then(() => {
              this.load();
              this.$info("Ubah peran user berhasil");
            })
            .catch(e => e);
        })
        .catch(e => e);
    },
    detail(item) {
      this.$refs.detailDlg.open(item);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    link(item) {
      window.open(item.link, "_blank");
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus user ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.name}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("user/drop", item))
        .then(() => {
          this.$info("User " + item.name + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {}
};
</script>
